import * as React from 'react';
import * as SwitchPrimitive from '@radix-ui/react-switch';

import { cn } from '@/lib/utils';

function Switch({
  className,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        'peer data-[state=checked]:bg-primary data-[state=unchecked]:bg-switch-background focus-visible:border-ring focus-visible:ring-ring/50 inline-flex h-[1.15rem] w-8 shrink-0 items-center rounded-full border border-transparent transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      {/* ONE token for the knob, in both states and both themes.
          It used to be `bg-card` plus a `dark:` override per state. The two
          overrides covered every state between them, so `--card` was dead in
          dark — and because they named DIFFERENT tokens (`--foreground` vs
          `--primary-foreground`, #f1f5f9 vs #ffffff) the knob changed colour
          as you toggled it, in dark mode only.

          `--switch-knob` is its own token because the knob is not a card, a
          foreground or a surface: it is a physical-looking object that has to
          stay lighter than the track in both themes, including when the track
          goes `--primary`. */}
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          'bg-switch-knob pointer-events-none block size-4 rounded-full ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-0',
        )}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
